module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.191/css/toolsmenu.css"